"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSpring = require("react-spring");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2;
var _excluded = ["variant", "horizontal"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Snackbar = function Snackbar(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$horizontal = _ref.horizontal,
    horizontal = _ref$horizontal === void 0 ? 'right' : _ref$horizontal,
    props = _objectWithoutProperties(_ref, _excluded);
  var getTransitionDirection = function getTransitionDirection() {
    if (horizontal === 'right') return 'translateX(-100%)';
    if (horizontal === 'left') return 'translateX(100%)';
  };
  return /*#__PURE__*/_react["default"].createElement(_reactSpring.Spring, {
    from: {},
    to: {}
  }, function (styles) {
    return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
      style: styles
    }, /*#__PURE__*/_react["default"].createElement(StyledSnackbar, _extends({
      variant: variant,
      horizontal: horizontal
    }, props), props.icon && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(SnackbarIconWrapper, null, props.icon)), /*#__PURE__*/_react["default"].createElement("span", null, props.text)));
  });
};
var _default = Snackbar;
exports["default"] = _default;
var SnackbarIconWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 50%;\n\tbackground: transparent;\n\tmargin: 0 0.5rem;\n\tborder-width: 2px;\n\tborder-style: solid;\n\tborder-color: ", ";\n\tdisplay: grid;\n\tplace-content: center;\n"])), function (props) {
  var _props$theme$buttonCo, _props$theme$buttonCo2, _props$variant;
  return (_props$theme$buttonCo = props.theme.buttonColors) === null || _props$theme$buttonCo === void 0 ? void 0 : (_props$theme$buttonCo2 = _props$theme$buttonCo[(_props$variant = props.variant) !== null && _props$variant !== void 0 ? _props$variant : 'primary']) === null || _props$theme$buttonCo2 === void 0 ? void 0 : _props$theme$buttonCo2.color;
});
var StyledSnackbar = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tposition: fixed;\n\tz-index: 99999;\n\tmargin: 1rem;\n\tpadding: 1rem;\n\tmin-width: 19rem;\n\tborder-radius: 50px;\n\t", "\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\ttop: ", ";\n\tbottom: ", ";\n\tleft: ", ";\n\ttransform: ", ";\n\n\tright: ", ";\n"])), (0, _styledSystem.variant)({
  prop: 'variant',
  scale: 'buttonColors'
}), function (props) {
  if (!props.vertical) {
    return '0';
  }
  if (props.vertical === 'top') return '0';
}, function (props) {
  if (props.vertical === 'bottom') return '0';
}, function (props) {
  if (!props.horizontal) {
    return '0';
  }
  if (props.horizontal === 'center') return '50%';
  if (props.horizontal === 'left') return '0';
}, function (props) {
  return props.horizontal === 'center' ? 'translateX(-50%)' : '';
}, function (props) {
  if (props.horizontal === 'right') {
    return '0';
  }
});